"use client"

import * as React from "react"
import { Link } from "react-router-dom"

import {
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import {
  notificationsCentreCategoryPath,
  notificationsCentrePath,
  type NotificationsCentreCategoryLink,
} from "@/constants/notificationsCentre"
import { notificationTypeAccentTextClass } from "@/constants/notificationDetailChrome"
import { notificationsCentreIconRailButtonClass } from "@/constants/sidebarChrome"
import { cn } from "@/lib/utils"

const navCategoryExpandedButton =
  "group-data-[state=expanded]:h-10 group-data-[state=expanded]:gap-2.5 group-data-[state=expanded]:text-[0.9375rem] group-data-[state=expanded]:leading-snug group-data-[state=expanded]:[&_svg]:size-5"

export function NavNotificationsCentreCategoryItem({
  link,
  active,
  iconRailOnly = false,
  onNavigate,
}: {
  link: NotificationsCentreCategoryLink | { id: "inbox"; label: string; icon: NotificationsCentreCategoryLink["icon"] }
  active: boolean
  iconRailOnly?: boolean
  onNavigate?: () => void
}): React.ReactElement {
  const Icon = link.icon
  const href = link.id === "inbox" ? notificationsCentrePath() : notificationsCentreCategoryPath(link.id)

  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        asChild
        tooltip={{
          children: link.label,
          hidden: !iconRailOnly,
          className: notificationTypeAccentTextClass(link.id),
        }}
        isActive={active}
        className={iconRailOnly ? notificationsCentreIconRailButtonClass : navCategoryExpandedButton}
      >
        <Link
          to={href}
          onClick={() => onNavigate?.()}
          data-notification-category-link={link.id}
        >
          <Icon />
          {iconRailOnly ? (
            <span className="sr-only">{link.label}</span>
          ) : (
            <span
              className={cn(
                "truncate transition-[opacity,margin,max-width] duration-200 ease-linear",
                "group-data-[collapsible=icon]:max-w-0 group-data-[collapsible=icon]:opacity-0 group-data-[collapsible=icon]:overflow-hidden"
              )}
            >
              {link.label}
            </span>
          )}
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  )
}
